import type { IPost, IPostComment } from '~/types/community';
import { walkCommentTree } from '~/components/utils/commentTree';

export const createBoostUsernames = (post: IPost, comments: IPostComment[]) => {
  const usernames = new Set();

  for (const comment of walkCommentTree(comments)) {
    usernames.add(comment.user_username);
  }

  usernames.add(post.user_username);

  return [...usernames];
};
